import { Link } from "react-router-dom";
import {
  Star
} from "lucide-react";

interface ServiceCardContentProps {
  id: string;
  name: string;
  hasReviews: boolean;
  averageRating: number;
  totalReviews: number;
  categories: string[];
  areaLabels: string[];
  description: string;
  onProviderClick?: () => void;
}

const ServiceCardContent = ({
  id,
  name,
  hasReviews,
  averageRating,
  totalReviews,
  categories,
  areaLabels,
  description,
  onProviderClick,
}: ServiceCardContentProps) => {
  return (
    <>
      <div className="mb-2 flex items-start justify-between gap-3">
        <Link to={`/service/${id}`} onClick={onProviderClick} className="block flex-1 min-w-0 pt-0.5">
          <h3 className="line-clamp-2 font-heading text-base font-semibold leading-snug text-brand-ink transition-colors hover:text-harbour">
            {name}
          </h3>
        </Link>
        <div className="flex items-center shrink-0 whitespace-nowrap pt-1 text-right">
          {hasReviews ? (
            <div className="flex items-center">
              <Star className="h-4 w-4 text-amber fill-amber" />
              <span className="ml-1 text-xs font-medium text-brand-ink">
                {averageRating.toFixed(1)}
                <span className="ml-1 text-xs text-brand-slate">({totalReviews})</span>
              </span>
            </div>
          ) : (
            <div className="flex items-center">
              <Star className="h-4 w-4 text-amber fill-amber" />
              <span className="ml-1 text-xs font-medium text-brand-ink">
                -
                <span className="ml-1 text-xs text-brand-slate">(0)</span>
              </span>
            </div>
          )}
        </div>
      </div>

      {categories.length > 0 && (
        <p className="mb-1.5 text-[length:var(--text-small)] text-brand-slate">
          {categories.slice(0, 2).join(" · ")}
          {categories.length > 2 && ` · +${categories.length - 2}`}
        </p>
      )}

      {areaLabels.length > 0 && (
        <p className="mb-2 text-[length:var(--text-small)] text-brand-slate">
          {areaLabels.slice(0, 2).join(" · ")}
          {areaLabels.length > 2 && ` · +${areaLabels.length - 2} more`}
        </p>
      )}

      <p className="mb-4 line-clamp-2 text-[length:var(--text-small)] text-brand-slate">
        {description}
      </p>
    </>
  );
};

export default ServiceCardContent;
